import { signIn } from '@/services/auth';

export default () => (
  (to, from, next) => {
    const { token } = to.query;

    if (!token) {
      next();
      return;
    }

    try {
      signIn(token);
      next(false);
    } catch (error) {
      next(error);
    }
  }
);
